import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminRequestPage } from './adminRequest';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';
@NgModule({
  declarations: [
    AdminRequestPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminRequestPage),
    CalendarModule,
  ],
  entryComponents: [
  ],
  providers: [
    RestProvider,
  ]
})
export class adminRequestPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/adminRequest/adminRequest.module.ts